import request from '../../utils/request';
const querystring = require('querystring')
 
//获取列表数据
export const fetchChannelById = query => {
    var list = request({
        url: 'comChannel/getData.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};

//获取列表数据
export const fetchData = query => {
    var list = request({
        url: 'comChannel/selectPage.do',
        method: 'post',
        data: querystring.stringify(query),
    });
    return list;
};
 
//启用-禁用 
export const changeStatus = query => {  
    var list = request({
        url: 'comChannel/changeStatus.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};
//添加渠道信息
export const saveForm = query => {  
    var list = request({
        url: 'comChannel/insert.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};

export const handDelete = query => {  
    var list = request({
        url: 'comChannel/delete.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};
export const changeForm = query => {  
    var list = request({
        url: 'comChannel/update.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};


export const fetchSelect = query => {  
    var list = request({
        url: 'comChannel/getListFetch.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};



